import React from "react";
import {
  getVariantValidationStats,
  type VariantList,
} from "@/app/components/product/utils/variantValidationUtils";

interface VariantValidationSummaryProps {
  variants: VariantList | undefined;
}

const VariantValidationSummary: React.FC<VariantValidationSummaryProps> = ({
  variants,
}) => {
  const stats = React.useMemo(
    () => getVariantValidationStats(variants),
    [variants],
  );

  if (stats.total === 0) {
    return null;
  }

  const readyCount = stats.total - stats.withIssues;

  return (
    <section className="mb-4 w-full rounded-2xl border border-muted bg-white p-3 sm:p-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
        <div>
          <h3 className="font-medium text-[#2f2a27]">Variant checklist</h3>
          <p className="text-sm text-muted-foreground">
            {readyCount} of {stats.total} variants look ready to submit
          </p>
        </div>

        <div className="grid grid-cols-1 gap-2 text-xs sm:flex sm:flex-wrap">
          {stats.missingSku > 0 ? (
            <span className="rounded-full bg-amber-100 px-3 py-1 text-amber-800">
              {stats.missingSku} missing SKU
            </span>
          ) : null}
          {stats.missingFeaturedImage > 0 ? (
            <span className="rounded-full bg-amber-100 px-3 py-1 text-amber-800">
              {stats.missingFeaturedImage} missing featured image
            </span>
          ) : null}
          {stats.missingAdditionalImages > 0 ? (
            <span className="rounded-full bg-amber-100 px-3 py-1 text-amber-800">
              {stats.missingAdditionalImages} missing additional images
            </span>
          ) : null}
          {stats.withIssues === 0 ? (
            <span className="rounded-full bg-green-100 px-3 py-1 text-green-800">
              All variants complete
            </span>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default VariantValidationSummary;
